import React, { useEffect, useState } from 'react';
import Lenis from 'lenis';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Competition from './components/Competition';
import Speakers from './components/Speakers';
import Schedule from './components/Schedule';
import Sponsors from './components/Sponsors';
import Register from './components/Register';
import Footer from './components/Footer';
import CursorTrail from './components/CursorTrail';
import LoadingScreen from './components/LoadingScreen';
import { useReducedMotion } from './hooks/useReducedMotion';

function App() {
  const prefersReducedMotion = useReducedMotion();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (prefersReducedMotion) return;

    // Lenis smooth scroll
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, [prefersReducedMotion]);

  const handleLoadingComplete = () => {
    setLoading(false);
  };

  return (
    <div className="min-h-screen">
      {loading && <LoadingScreen onComplete={handleLoadingComplete} />}
      <CursorTrail />
      <Navbar />
      <main className="pt-16">
        <Hero />
        <About />
        <Competition />
        <Speakers />
        <Schedule />
        <Sponsors />
        <Register />
      </main>
      <Footer />
    </div>
  );
}

export default App;